// ===============================
// Section-to-Section Transition (reusable)
// ===============================

(function () {
  const WRAPPER_SELECTOR = '.about-transition-wrapper, .experience-transition-wrapper, .homepage-transition-wrapper';
  const PATHS = {
    landscape: {
      initial: 'M 0 90 V 90 Q 80 90 160 90 V 90 z',
      scrollDown: ['M 0 90 V 90 Q 80 90 160 90 V 90 z', 'M 0 90 V 45 Q 80 0 160 45 V 90 z', 'M 0 90 V 0 Q 80 0 160 0 V 90 z', 'M 0 0 V 90 Q 80 90 160 90 V 0 z', 'M 0 0 V 45 Q 80 90 160 45 V 0 z', 'M 0 0 V 0 Q 80 0 160 0 V 0 z'],
      scrollUp: ['M 0 0 V 0 Q 80 0 160 0 V 0 z', 'M 0 0 V 45 Q 80 90 160 45 V 0 z', 'M 0 0 V 90 Q 80 90 160 90 V 0 z', 'M 0 90 V 0 Q 80 0 160 0 V 90 z', 'M 0 90 V 45 Q 80 0 160 45 V 90 z', 'M 0 90 V 90 Q 80 90 160 90 V 90 z']
    },
    portrait: {
      initial: 'M 0 160 V 160 Q 45 160 90 160 V 160 z',
      scrollDown: ['M 0 160 V 160 Q 45 160 90 160 V 160 z', 'M 0 160 V 80 Q 45 0 90 80 V 160 z', 'M 0 160 V 0 Q 45 0 90 0 V 160 z', 'M 0 0 V 160 Q 45 160 90 160 V 0 z', 'M 0 0 V 80 Q 45 160 90 80 V 0 z', 'M 0 0 V 0 Q 45 0 90 0 V 0 z'],
      scrollUp: ['M 0 0 V 0 Q 45 0 90 0 V 0 z', 'M 0 0 V 80 Q 45 160 90 80 V 0 z', 'M 0 0 V 160 Q 45 160 90 160 V 0 z', 'M 0 160 V 0 Q 45 0 90 0 V 160 z', 'M 0 160 V 80 Q 45 0 90 80 V 160 z', 'M 0 160 V 160 Q 45 160 90 160 V 160 z']
    }
  };

  function getViewportBox() {
    const width = Math.max(window.innerWidth, 1);
    const height = Math.max(window.innerHeight, 1);
    return { width, height };
  }

  function isPortrait() {
    return window.innerHeight > window.innerWidth;
  }

  function buildPaths(width, height) {
    const midX = width / 2;
    const midY = height / 2;

    return {
      initial: `M 0 ${height} V ${height} Q ${midX} ${height} ${width} ${height} V ${height} z`,
      scrollDown: [
        `M 0 ${height} V ${height} Q ${midX} ${height} ${width} ${height} V ${height} z`,
        `M 0 ${height} V ${midY} Q ${midX} 0 ${width} ${midY} V ${height} z`,
        `M 0 ${height} V 0 Q ${midX} 0 ${width} 0 V ${height} z`,
        `M 0 0 V ${height} Q ${midX} ${height} ${width} ${height} V 0 z`,
        `M 0 0 V ${midY} Q ${midX} ${height} ${width} ${midY} V 0 z`,
        `M 0 0 V 0 Q ${midX} 0 ${width} 0 V 0 z`
      ],
      scrollUp: [
        `M 0 0 V 0 Q ${midX} 0 ${width} 0 V 0 z`,
        `M 0 0 V ${midY} Q ${midX} ${height} ${width} ${midY} V 0 z`,
        `M 0 0 V ${height} Q ${midX} ${height} ${width} ${height} V 0 z`,
        `M 0 ${height} V 0 Q ${midX} 0 ${width} 0 V ${height} z`,
        `M 0 ${height} V ${midY} Q ${midX} 0 ${width} ${midY} V ${height} z`,
        `M 0 ${height} V ${height} Q ${midX} ${height} ${width} ${height} V ${height} z`
      ]
    };
  }

  function setOverlayViewBox(wrapper, width, height) {
    const overlay = wrapper.querySelector('.overlay');
    if (!overlay) return;
    overlay.setAttribute('viewBox', `0 0 ${width} ${height}`);
    const img = overlay.querySelector('.overlay__image');
    if (img) {
      img.setAttribute('width', `${width}`);
      img.setAttribute('height', `${height}`);
    }
  }

  function forceScrollToTop() {
    window.scrollTo(0, 0);
    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(0, { immediate: true });
    }
  }

  function getScrollTop() {
    if (window.lenis && typeof window.lenis.scroll === 'number') {
      return window.lenis.scroll;
    }
    return window.scrollY ?? window.pageYOffset ?? document.documentElement.scrollTop ?? 0;
  }

  function isMobileViewport() {
    // Include tablets (e.g. iPad) via pointer:coarse so Lenis is paused and
    // touch-swipe gestures reliably trigger the section morph transition.
    return window.matchMedia('(max-width: 768px)').matches || window.matchMedia('(pointer: coarse)').matches;
  }

  document.addEventListener('DOMContentLoaded', () => {
    const transitionWrapper = document.querySelector(WRAPPER_SELECTOR);
    if (!transitionWrapper) return;
    const isHomepageTransition = transitionWrapper.classList.contains('homepage-transition-wrapper');
    const isExperienceTransition = transitionWrapper.classList.contains('experience-transition-wrapper');
    const shouldPersistOverlayInSection2 = isHomepageTransition || isExperienceTransition;
    const shouldAutoSyncOverlayPersist = shouldPersistOverlayInSection2 && !isHomepageTransition;
    const HOMEPAGE_BACK_TRIGGER_Y = 2;
    const PERSIST_REVERSE_PREFADE_MS = 220;
    const REVERSE_GUARD_MS = 500;
    const REVERSE_WHEEL_DELTA_THRESHOLD = 20;

    // Always start at top on transition pages (fixes collapsed layout when refreshing from scrolled position),
    // except when arriving via a deep-link hash (e.g. #book-a-visit) where the browser should honor the anchor.
    const hasHash = !!window.location.hash;
    if (!hasHash) {
      if (typeof history !== 'undefined' && history.scrollRestoration) {
        history.scrollRestoration = 'manual';
      }
      forceScrollToTop();
      requestAnimationFrame(function () {
        requestAnimationFrame(forceScrollToTop);
      });
      setTimeout(forceScrollToTop, 0);
      setTimeout(forceScrollToTop, 100);
    }

    const overlayPath = transitionWrapper.querySelector('.overlay__path');
    const section1 = transitionWrapper.querySelector('#section1');
    const section2 = transitionWrapper.querySelector('#section2');
    if (!overlayPath || !section1 || !section2) return;

    let isAnimating = false;
    let currentSection = 1;
    let section2ActivatedAt = 0;
    // Slightly slower homepage timing keeps the transition smoother.
    const speed = isHomepageTransition ? 1.08 : 0.9;
    const t1 = 0.7 * speed;
    const t2 = 0.3 * speed;

    function getPaths() {
      return isPortrait() ? PATHS.portrait : PATHS.landscape;
    }
    function applyOverlayOrientation() {
      const viewport = isPortrait() ? PATHS.portrait : PATHS.landscape;
      const overlay = transitionWrapper.querySelector('.overlay');
      if (overlay) {
        const viewBoxWidth = viewport === PATHS.portrait ? 90 : 160;
        const viewBoxHeight = viewport === PATHS.portrait ? 160 : 90;
        overlay.setAttribute('viewBox', `0 0 ${viewBoxWidth} ${viewBoxHeight}`);
      }
      const paths = getPaths();
      const section2OverlayPath = shouldPersistOverlayInSection2 ? paths.scrollDown[3] : paths.scrollDown[5];
      overlayPath.setAttribute('d', currentSection === 1 ? paths.initial : section2OverlayPath);
    }

    function setSection2OverlayPersist(enabled) {
      if (!shouldPersistOverlayInSection2) return;
      transitionWrapper.classList.toggle('section2-overlay-persist', !!enabled);
    }

    function syncSection2OverlayPersist() {
      if (!shouldAutoSyncOverlayPersist) return;
      if (!shouldPersistOverlayInSection2) return;
      if (currentSection !== 2) {
        setSection2OverlayPersist(false);
        return;
      }

      const rect = section2.getBoundingClientRect();
      const isSection2Visible = rect.bottom > 0 && rect.top < window.innerHeight;
      setSection2OverlayPersist(isSection2Visible);
    }

    applyOverlayOrientation();
    window.addEventListener('resize', () => { if (!isAnimating) applyOverlayOrientation(); });
    if (shouldAutoSyncOverlayPersist) {
      window.addEventListener('scroll', syncSection2OverlayPersist, { passive: true });
    }

    // Keep internal transition state in sync when other scripts
    // force section changes (e.g. CTA jump to #book-a-visit).
    document.addEventListener('section2Activated', () => {
      currentSection = 2;
      section2ActivatedAt = Date.now();
      transitionWrapper.classList.add('section2-pin-active');
      setSection2OverlayPersist(true);
      section1.classList.remove('section--active');
      section2.classList.add('section--active');
      document.body.classList.add('section2-active');
      applyOverlayOrientation();
      if (shouldAutoSyncOverlayPersist) {
        syncSection2OverlayPersist();
      }
    });

    document.addEventListener('section1Activated', () => {
      currentSection = 1;
      transitionWrapper.classList.remove('section2-pin-active');
      setSection2OverlayPersist(false);
      section2.classList.remove('section--active');
      section1.classList.add('section--active');
      document.body.classList.remove('section2-active');
      applyOverlayOrientation();
      pauseLenisForSection1();
    });

    const pauseLenisForSection1 = () => {
      if (!isMobileViewport() || currentSection !== 1) return;
      if (window.lenis && typeof window.lenis.stop === 'function') {
        window.lenis.stop();
      }
    };

    const lockScroll = () => {
      const isMobile = isMobileViewport();
      const vh = isMobile ? '100dvh' : '100vh';
      document.body.style.overflow = 'hidden';
      document.body.style.height = vh;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.height = vh;
      if (window.lenis) window.lenis.stop();
    };

    const unlockScroll = () => {
      document.body.style.overflow = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.height = '';
      if (window.lenis) {
        if (currentSection === 2) {
          window.scrollTo(0, 0);
          window.lenis.scrollTo(0, { immediate: true });
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              window.lenis.start();
              if (window.lenis.resize) window.lenis.resize();
            });
          });
        } else {
          // Keep scrolling responsive when section 1 is active.
          window.lenis.start();
          if (window.lenis.resize) window.lenis.resize();
        }
      }
    };

    const smoothScrollToTop = (done) => {
      const startY = getScrollTop();
      if (startY <= 0) {
        done();
        return;
      }

      const duration = isHomepageTransition ? 220 : 0;
      if (duration <= 0) {
        window.scrollTo(0, 0);
        if (window.lenis && typeof window.lenis.scrollTo === 'function') {
          window.lenis.scrollTo(0, { immediate: true });
        }
        done();
        return;
      }

      const startTime = performance.now();
      const easeOut = (t) => 1 - Math.pow(1 - t, 3);

      function step(now) {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const nextY = Math.max(startY * (1 - easeOut(progress)), 0);
        window.scrollTo(0, nextY);
        if (window.lenis && typeof window.lenis.scrollTo === 'function') {
          window.lenis.scrollTo(nextY, { immediate: true });
        }

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          window.scrollTo(0, 0);
          if (window.lenis && typeof window.lenis.scrollTo === 'function') {
            window.lenis.scrollTo(0, { immediate: true });
          }
          done();
        }
      }

      requestAnimationFrame(step);
    };

    const scrollDownTimeline = () => {
      isAnimating = true;
      lockScroll();
      gsap.killTweensOf(overlayPath);
      void overlayPath.offsetHeight;

      const paths = getPaths().scrollDown;
      const tl = gsap.timeline({
        onComplete: () => {
          isAnimating = false;
          currentSection = 2;
          if (shouldPersistOverlayInSection2) {
            setSection2OverlayPersist(true);
            overlayPath.setAttribute('d', paths[3]);
          }
          // Allow the transition wrapper to expand so scrolling can continue on section 2
          transitionWrapper.classList.add('section2-pin-active');
          unlockScroll();
          document.body.classList.add('section2-active');
          document.dispatchEvent(new CustomEvent('section2Activated'));
        }
      });

      tl.set(overlayPath, { attr: { d: paths[0] } });
      tl.to(overlayPath, { duration: t1, ease: 'power4.in', attr: { d: paths[1] } });
      tl.to(overlayPath, {
        duration: t2,
        ease: 'power2',
        attr: { d: paths[2] },
        onComplete: () => {
          section1.classList.remove('section--active');
          section2.classList.add('section--active');
        }
      });
      tl.set(overlayPath, { attr: { d: paths[3] } });
      if (!shouldPersistOverlayInSection2) {
        tl.to(overlayPath, { duration: t2, ease: 'power2.in', attr: { d: paths[4] } });
        tl.to(overlayPath, { duration: t1, ease: 'power4', attr: { d: paths[5] } });
      }

      return tl;
    };

    const scrollUpTimeline = () => {
      isAnimating = true;
      lockScroll();
      gsap.killTweensOf(overlayPath);
      void overlayPath.offsetHeight;
      // Bring overlay back above content before reverse morph starts.
      setSection2OverlayPersist(false);

      const paths = getPaths().scrollUp;
      const tl = gsap.timeline({
        onComplete: () => {
          isAnimating = false;
          currentSection = 1;
          if (shouldPersistOverlayInSection2) document.dispatchEvent(new CustomEvent('section1Activated'));
          // Restore compact wrapper when returning to section 1
          transitionWrapper.classList.remove('section2-pin-active');
          unlockScroll();
          document.body.classList.remove('section2-active');
        }
      });

      if (shouldPersistOverlayInSection2) {
        // Overlay is persisted at paths[3] in section2, so reverse from there.
        tl.set(overlayPath, { attr: { d: paths[3] } });
        tl.to(overlayPath, {
          duration: t2,
          ease: 'power2.in',
          attr: { d: paths[4] },
          onComplete: () => {
            section2.classList.remove('section--active');
            section1.classList.add('section--active');
          }
        });
        tl.to(overlayPath, { duration: t1, ease: 'power4', attr: { d: paths[5] } });
      } else {
        tl.set(overlayPath, { attr: { d: paths[0] } });
        tl.to(overlayPath, { duration: t1, ease: 'power4.in', attr: { d: paths[1] } });
        tl.to(overlayPath, {
          duration: t2,
          ease: 'power2',
          attr: { d: paths[2] },
          onComplete: () => {
            section2.classList.remove('section--active');
            section1.classList.add('section--active');
            document.dispatchEvent(new CustomEvent('section1Activated'));
          }
        });
        tl.set(overlayPath, { attr: { d: paths[3] } });
        tl.to(overlayPath, { duration: t2, ease: 'power2.in', attr: { d: paths[4] } });
        tl.to(overlayPath, { duration: t1, ease: 'power4', attr: { d: paths[5] } });
      }

      return tl;
    };

    const triggerScrollUpTransition = () => {
      if (isAnimating) return;
      if (Date.now() - section2ActivatedAt < REVERSE_GUARD_MS) return;
      isAnimating = true;

      const startReverseMorph = () => {
        const reverseDelay = shouldPersistOverlayInSection2 ? PERSIST_REVERSE_PREFADE_MS : 0;
        window.setTimeout(() => {
          scrollUpTimeline().play();
        }, reverseDelay);
      };

      if (isHomepageTransition) {
        document.dispatchEvent(new CustomEvent('homepageSection2ReverseStart'));
      }
      if (isExperienceTransition) {
        document.dispatchEvent(new CustomEvent('experienceSection2ReverseStart'));
      }

      smoothScrollToTop(startReverseMorph);
    };

    const atTransitionTop = () => getScrollTop() <= 2;

    const tryStartScrollDown = () => {
      if (isAnimating || currentSection !== 1 || !atTransitionTop()) return false;
      scrollDownTimeline().play();
      return true;
    };

    // Use capture: true so we get wheel events before Lenis
    window.addEventListener('wheel', (e) => {
      if (isAnimating) return;
      const deltaY = e.deltaY;
      const direction = deltaY > 0 ? 'down' : 'up';

      if (direction === 'down' && currentSection === 1 && atTransitionTop()) {
        e.preventDefault();
        e.stopPropagation();
        scrollDownTimeline().play();
      }
      const backTriggerY = isHomepageTransition ? HOMEPAGE_BACK_TRIGGER_Y : 2;
      if (
        direction === 'up' &&
        currentSection === 2 &&
        atTransitionTop() &&
        deltaY <= -REVERSE_WHEEL_DELTA_THRESHOLD
      ) {
        e.preventDefault();
        e.stopPropagation();
        triggerScrollUpTransition();
      }
    }, { passive: false, capture: true });

    let touchStartY = 0;
    let touchStartX = 0;
    let touchGestureDecided = false;
    let touchIsVertical = false;
    const minSwipeDistance = isMobileViewport() ? 40 : 50;
    const touchCaptureOptions = { passive: false, capture: true };
    const touchStartCaptureOptions = { passive: true, capture: true };

    const resetTouchGesture = () => {
      touchGestureDecided = false;
      touchIsVertical = false;
    };

    transitionWrapper.addEventListener('touchstart', (e) => {
      if (!e.touches.length) return;
      touchStartY = e.touches[0].clientY;
      touchStartX = e.touches[0].clientX;
      resetTouchGesture();
    }, touchStartCaptureOptions);

    // Intercept before Swiper/Lenis on iOS (capture phase). Prevent pull-to-refresh
    // and native scroll so the morph transition can run at the top of the page.
    const handleTouchMove = (e) => {
      if (isAnimating || !e.touches.length) return;

      const currentY = e.touches[0].clientY;
      const currentX = e.touches[0].clientX;
      const deltaY = touchStartY - currentY;
      const deltaX = touchStartX - currentX;
      const absY = Math.abs(deltaY);
      const absX = Math.abs(deltaX);

      // Pre-gesture guard: on tablet, Lenis (smoothTouch:true) begins scrolling before the
      // gesture is decided. Prevent default early — before the 8px decision threshold — when
      // the movement looks vertical and we're at the section boundary. This stops Lenis from
      // advancing lenis.scroll past the atTransitionTop() threshold before we can block it.
      if (!touchGestureDecided && absY > 3 && absY > absX) {
        const earlySection1 = deltaY > 0 && currentSection === 1 && atTransitionTop();
        const earlySection2 = deltaY < 0 && currentSection === 2 && atTransitionTop();
        if (earlySection1 || earlySection2) {
          e.preventDefault();
          if (window.lenis && typeof window.lenis.scrollTo === 'function') {
            window.lenis.scrollTo(0, { immediate: true });
          }
        }
      }

      if (!touchGestureDecided && (absY > 8 || absX > 8)) {
        touchGestureDecided = true;
        touchIsVertical = absY > absX;
      }

      if (!touchIsVertical) return;

      const swipeUpFromSection1 =
        deltaY > 0 && currentSection === 1 && atTransitionTop();
      const swipeDownFromSection2 =
        deltaY < 0 && currentSection === 2 && atTransitionTop();

      if (swipeUpFromSection1 || swipeDownFromSection2) {
        e.preventDefault();
        if (window.lenis && typeof window.lenis.scrollTo === 'function') {
          window.lenis.scrollTo(0, { immediate: true });
        }
      }
    };

    const handleTouchEnd = (e) => {
      if (isAnimating || !e.changedTouches.length) return;

      const touchEndY = e.changedTouches[0].clientY;
      const swipeDistance = touchStartY - touchEndY;

      if (
        touchIsVertical &&
        swipeDistance > minSwipeDistance &&
        currentSection === 1 &&
        atTransitionTop()
      ) {
        e.preventDefault();
        tryStartScrollDown();
      } else if (
        touchIsVertical &&
        swipeDistance < -minSwipeDistance &&
        currentSection === 2 &&
        atTransitionTop()
      ) {
        e.preventDefault();
        triggerScrollUpTransition();
      }

      resetTouchGesture();
    };

    window.addEventListener('touchmove', handleTouchMove, touchCaptureOptions);
    window.addEventListener('touchend', handleTouchEnd, touchCaptureOptions);
    window.addEventListener('touchcancel', resetTouchGesture, touchStartCaptureOptions);

    section1.classList.add('section--active');

    // On mobile, keep Lenis paused on section 1 so swipe triggers the morph (not page scroll).
    if (isMobileViewport()) {
      pauseLenisForSection1();
    } else if (window.lenis && typeof window.lenis.start === 'function') {
      window.lenis.start();
    }
  });
})();
